import interfaceApi from '@/api/admin/interfaceApi'
import { queryKeys } from '@/constant/common'
import { useAuthContext } from '@/features/auth/context'
import useUser from '@/features/auth/hooks/useUser'
import { APIResponseList, SearchParams } from '@/types/common'
import { Interface } from '@/types/interface'
import { UserOrganization } from '@/types/user'
import { filterInterfacesByPermission } from '@/utils/permissionUtils'
import { queryStringify } from '@/ultils'
import { QueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'

function useSearchInterface(
  searchParams: SearchParams = {},
  queryOptions?: QueryOptions,
  isWeather = false,
): UseQueryResult<APIResponseList<Interface>, any> {
  const { interfaceId } = useAuthContext()
  const { data: user } = useUser<UserOrganization>()

  return useQuery(
    [queryKeys.interface, interfaceId, queryStringify(searchParams), user?.id],
    async () => {
      const { data } = await interfaceApi.getAll({
        ...searchParams,
      })

      if (!data) return null

      let interfaceList =
        data.data.length > 0 &&
        data?.data.map((item: any) => {
          return {
            id: item.id,
            interface_name: item.interfaceName,
            organizations: item.organizations,
            weatherLinkStation: item.weatherLinkStations,
            status: item.status,
            updated_at: item.updatedAt,
            created_at: item.createdAt,
            state: item.state,
            timeZone: item.timeZone,
            interfaceCustomName: item.interfaceCustomName,
            country: item.country,
            timeZoneName: item.timeZoneName,
          }
        })

      // Apply permission-based filtering
      if (user && interfaceList) {
        interfaceList = filterInterfacesByPermission(user, interfaceList)
      }

      return {
        list: interfaceList,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: data.totalCount,
        totalPage: data.totalPage,
      }
    },
    { retry: 1, refetchOnWindowFocus: true, ...queryOptions },
  )
}

export default useSearchInterface
